enum DialogType {
	LOGIN = "login",
	LOGOUT = "logout",
	HELP = "help"
}

export default DialogType;